import Vue from 'vue'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'G-LBQNYKF733',
  router,
  autoTracking: {
    screenview: true
  },
  commands: {
    trackStoreClick(value = 1) {
      this.$ga.event('event', 'click', 'onlinestore', value)
    }
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
